import { render, staticRenderFns } from "./appLayout.vue?vue&type=template&id=fc47c91e&"
var script = {}
import style0 from "./appLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports